import React, { useEffect, useState } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import Table from 'components/Table/Table';
import { makeStyles } from '@material-ui/core/styles';
import RegularButton from 'components/CustomButtons/Button';
import { Add, Cancel, Delete, DeleteForever, DeleteSweep, LockOpen, Restore, Save } from '@material-ui/icons';
import { FormControl, InputLabel, MenuItem, Select, Tooltip } from '@material-ui/core';
import { wsPost, wsUpdate, wsRemove, wsGet } from 'services/WService';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Switch } from '@material-ui/core';
const useStyles = makeStyles(styles);

function UserAppModal(props) {
  const { model, setOpen, showNotify, canCreate = true, canDelete = true, reload  } = props;
  const classes = useStyles();
  const [userApps, setUserApps] = useState([]);
  const [apps, setApps] = useState([]);
  const [newData, setNewData] = useState();

  async function loadApps() {
    let res = await wsGet(`oauth/app`);
    if (res.success) {
      setApps(res.data);
    }
  }

  async function loadUserApps() {
    setUserApps([]);
    let res = await wsGet(`oauth/user/${model.id}/app`);
    if (res.success) {
      setUserApps(res.data);
    }
  }

  async function saveApp() {
    if (newData?.oauth_app_id === undefined) {
      return;
    }
    let res = await wsPost(`oauth/user/${model.id}/app`, {
      oauth_app_id: newData.oauth_app_id,
    });
    if (res.success) {
      showNotify(res.message);
      await loadUserApps();
      setNewData(undefined);
    }
  }

  async function deleteApp(app) {
    let res = await wsRemove(`oauth/user/${model.id}/app/${app.id}`);
    if (res.success) {
      showNotify(res.message);
      await loadUserApps();
    }
  }

  async function restoreApp(app) {
    let res = await wsUpdate(`oauth/user/${model.id}/app/${app.id}`, {
      reset_uuid: 'Y',
    });
    if (res.success) {
      showNotify(res.message);
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function loginApp(app) {
    let res = await wsUpdate(`oauth/user/${model.id}/app/${app.id}`, {
      free_login: 'Y',
    });
    if (res.success) {
      alert(`Contraseña temporal: ${res.data.free_login_password}`);
      showNotify(res.message);
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function deleteAllUserTokens(userId) {
    let res = await wsRemove(`oauth/${userId}/delete-all-user-tokens`);
    if (res.success) {
      showNotify(res.message);
    } else {
      showNotify(res.message, 'error');
    }
  }
  async function deleteFieldDataAppUser(deviceId) {
    let res = await wsRemove(`oauth/${deviceId}/delete-field-data-app-user`);
    if (res.success) {
      showNotify(res.message);
      if (reload) reload();
      setOpen({ open: false });
      setUserApps([]);
    } else {
      showNotify(res.message, 'error');
    }
  }

  const [alert2, setAlert2] = useState(null);
  const hideAlert = () => {
    setAlert2(null);
  };
  function confirm(modelId) {
    setAlert2(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Esta seguro que desea eliminar todos los dispositivos asociados al vendedor?"
        onConfirm={() => {
          allDeleteFieldDataAppUser(modelId);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  async function allDeleteFieldDataAppUser(userId) {
    let res = await wsRemove(`oauth/${userId}/all-delete-field-data-app-user`);
    if (res.success) {
      showNotify(res.message);
      if (reload) reload();
      setOpen({ open: false });
      setUserApps([]);
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function toggleValidation(app, field, value) {
    const payload = {};
    payload[field] = value ? "1" : "0";
    //cada aplicación lleva sus propias validaciones: hay que decir sobre cuál escribir
    payload.oauth_app_id = app.oauth_app_id ?? app.app?.id;
    let res = await wsUpdate(`movil/update/${model.id}/validation`, payload);
    if (res.success) {
      showNotify(res.message);
      await loadUserApps();
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function changeState(deviceId, field, value) {
    const payload = {};
    payload[field] = value ? "A" : "I";
    let res = await wsUpdate(`oauth/${deviceId}/change-state-device`, payload);
    if (res.success) {
      showNotify(res.message);
      await loadUserApps();
    } else {
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    loadApps();
  }, []);

  useEffect(() => {
    if (model.open === true) {
      loadUserApps();
    }
  }, [model]);

  const descriptions = userApps.map(app => app?.app?.description);
  const hasTomador = descriptions.includes('Tomador de pedidos');
  const hasSupervisor = descriptions.includes('Supervisor');
  const hasEntregas = descriptions.includes('Entregas');

  const deviceTableData = userApps.flatMap((app, index) =>
    app.user_devices.map(device => [
      index + 1,
      app.app.description,
      device.rsales_manufacturer,
      device.rsales_model,
      <>
        <Tooltip title="Eliminar datos de fabricante">
          <RegularButton
            round
            simple
            justIcon
            color="danger"
            onClick={() => deleteFieldDataAppUser(device.id)}
          >
            <DeleteForever />
          </RegularButton>
        </Tooltip>
        <Tooltip title="Activar el estado del dispositivo">
          <Switch
            checked={device.state === "A"}
            onChange={(e) => {
              const checked = e.target.checked;
              changeState(device.id, "state", checked);
            }}
            color="secondary"
          />
        </Tooltip>
      </>,
    ])
  );


  return (
    <>
    {alert2}
    <Modal
      title={`Aplicaciones ${model.name}`}
      model={model}
      setOpen={setOpen}
      disabledSave
      hideSave
      fullWidth
      maxWidth="sm"
    >
      {canCreate && (
        <RegularButton
          justIcon
          color="success"
          onClick={() => {
            if (newData === undefined) {
              setNewData({});
            } else {
              saveApp();
            }
          }}
        >
          {newData === undefined ? <Add /> : <Save />}
        </RegularButton>
      )}

      {newData !== undefined && (
        <>
          <RegularButton
            justIcon
            color="danger"
            onClick={() => {
              setNewData(undefined);
            }}
          >
            <Cancel />
          </RegularButton>
          <FormControl fullWidth margin="normal" size="small">
            <InputLabel>Nueva aplicación</InputLabel>
            <Select
              onChange={(e) => setNewData({ oauth_app_id: e.target.value })}
              value={newData.oauth_app_id || ''}
            >
              {apps
                .filter((app) => {
                  let items = userApps.map((item) => item.app.id);
                  return !items.includes(app.id);
                })
                .map((app) => {
                  return (
                    <MenuItem value={app.id} key={app.id}>
                      {app.description}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </>
      )}
      <Table
        tableHead={['#', 'Aplicación', 'Acciones']}
        tableData={userApps.map((app, index) => {
          return [
            index + 1,
            app.app.description,
            <>
              <Tooltip title="Resetear dispositivo">
                <RegularButton round simple justIcon color="info" onClick={() => restoreApp(app)}>
                  <Restore />
                </RegularButton>
              </Tooltip>
              <Tooltip title="Inicio sesión">
                <RegularButton round simple justIcon color="warning" onClick={() => loginApp(app)}>
                  <LockOpen />
                </RegularButton>
              </Tooltip>
              {canDelete && (
                <Tooltip title="Eliminar accesso">
                  <RegularButton
                    round
                    simple
                    justIcon
                    color="danger"
                    onClick={() => deleteApp(app)}
                  >
                    <Delete />
                  </RegularButton>
                </Tooltip>
              )}

              <Tooltip title="Eliminar tokens">
                <RegularButton
                  round
                  simple
                  justIcon
                  color="danger"
                  onClick={() => deleteAllUserTokens(model.id)}
                >
                  <DeleteSweep />
                </RegularButton>
              </Tooltip>
              <Tooltip title="Eliminar todos los datos del fabricante">
                <RegularButton
                  round
                  simple
                  justIcon
                  color="danger"
                  disabled={app.user_devices.length === 0}
                  onClick={() => confirm(model.id)}
                >
                  <DeleteForever />
                </RegularButton>
              </Tooltip>      
              {/* Estos dos son propios del tomador de pedidos */}
              {app.app?.description === 'Tomador de pedidos' ? (
                <>
                  <Tooltip title="Usar GPS con mayor precisión">
                    <Switch
                      checked={app.optimized_gps === "1"}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        toggleValidation(app, "optimized_gps", checked);
                      }}
                      color="secondary"
                    />
                  </Tooltip>
                  <Tooltip title="Validar distancia al crear pedidos">
                    <Switch
                      checked={app.validate_distace === "1"}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        toggleValidation(app, "validate_distace", checked);
                      }}
                      color="secondary"
                    />
                  </Tooltip>
                  <Tooltip title="Validar distancia al tomar la foto del mueble">
                    <Switch
                      checked={app.validate_furniture_distance === "1"}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        toggleValidation(app, "validate_furniture_distance", checked);
                      }}
                      color="secondary"
                    />
                  </Tooltip>
                  <Tooltip title="Permitir corregir la foto del mueble el mismo día">
                    <Switch
                      checked={app.edit_furniture_photo === "1"}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        toggleValidation(app, "edit_furniture_photo", checked);
                      }}
                      color="secondary"
                    />
                  </Tooltip>
                  <Tooltip title="Permitir digitar pedidos fuera de la ruta hoy (se apaga al cambiar el día)">
                    <Switch
                      checked={app.remote_order_auth === "1"}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        toggleValidation(app, "remote_order_auth", checked);
                      }}
                      color="secondary"
                    />
                  </Tooltip>
                  <Tooltip title="Permitir cerrar la operación antes de su hora de cierre hoy (se apaga al cambiar el día)">
                    <Switch
                      checked={app.early_close_auth === "1"}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        toggleValidation(app, "early_close_auth", checked);
                      }}
                      color="secondary"
                    />
                  </Tooltip>
                </>
              ) : undefined}
              {/* Estos dos son propios de entregas */}
              {app.app?.description === 'Entregas' ? (
                <>
                  <Tooltip title="Validar distancia al cliente con la distancia general, cuando el responsable es el vendedor (apaga la de la ruta; se aplica al sincronizar)">
                    <Switch
                      checked={app.validate_distace === "1"}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        toggleValidation(app, "validate_distace", checked);
                      }}
                      color="secondary"
                    />
                  </Tooltip>
                  <Tooltip title="Validar distancia al cliente con la distancia de la ruta, cuando el responsable es el vendedor (apaga la general; se aplica al sincronizar)">
                    <Switch
                      checked={app.route_distance === "1"}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        toggleValidation(app, "route_distance", checked);
                      }}
                      color="secondary"
                    />
                  </Tooltip>
                </>
              ) : undefined}
              {/* Estos dos aplican a las tres aplicaciones */}
              <Tooltip title="Exigir la última versión del aplicativo al iniciar sesión">
                <Switch
                  checked={app.validate_version === "1"}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    toggleValidation(app, "validate_version", checked);
                  }}
                  color="secondary"
                />
              </Tooltip>
              <Tooltip title="Restringir si usa GPS falso">
                <Switch
                  checked={app.false_gps === "1"}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    toggleValidation(app, "false_gps", checked);
                  }}
                  color="secondary"
                />
              </Tooltip>
              <Tooltip title="Cargar productos infaltables en el pedido">
                <Switch
                  checked={app.must_have_products === "1"}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    toggleValidation(app, "must_have_products", checked);
                  }}
                  color="secondary"
                />
              </Tooltip>
            </>,
          ];
        })}
      />
      {(hasTomador || hasSupervisor || hasEntregas) && (
        <Table
          tableHead={['#', 'Aplicación', 'Fabricante', 'Modelo', 'Acciones']}
          tableData={deviceTableData}
        />
      )}
    </Modal>
    </>
  );
}

export default UserAppModal;
